import Vue from "vue";
import Router from "vue-router";
import SignUpPage from "@/components/SignUpPage";
import SetPasswordPage from "@/components/SetPasswordPage";
import SignIn from "@/components/SignIn";
import ConfirmationPage from "@/components/ConfirmationPage";
import MyAccount from "@/components/MyAccount";
import ListPage from "@/components/ListPage";
import PrivacyPage from "@/components/PrivacyPage";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "ListPage",
      component: ListPage
    },
    {
      path: "/w/:word/:pos",
      name: "ListPage",
      component: ListPage
    },
    // {
    //   path: "/list",
    //   name: "ListPage",
    //   component: ListPage
    // },
    {
      path: "/profile",
      name: "MyAccount",
      component: MyAccount
    },
    {
      path: "/confirmation/:token",
      name: "ConfirmationPage",
      component: ConfirmationPage
    },
    {
      path: "/set_password",
      name: "SetPasswordPage",
      component: SetPasswordPage
    },
    {
      path: "/sign_up",
      name: "SignUp",
      component: SignUpPage
    },
    {
      path: "/sign_in",
      name: "SignIn",
      component: SignIn
    },
    {
      path: "/privacy",
      name: "PrivacyPage",
      component: PrivacyPage
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js